import type { GalleryOptions_Layout_Type, RichContent } from 'ricos-schema';

import type { DraftContent } from '../../../../../types';

type TestValues = {
  type: GalleryOptions_Layout_Type;
  input: RichContent;
  expectedOutput: DraftContent;
};

export const testValues = [
  {
    type: 'EMPTY',
    input: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: '0tsbe2',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    expectedOutput: {
      blocks: [
        {
          key: '0tsbe2',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
      documentStyle: {},
      VERSION: '9.5.18',
      ID: '05375aa2-e66a-412d-b4b1-1bcb9d3d7130',
    },
  },
  {
    type: 'WITH TEXT',
    input: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: '0tsbe2',
          nodes: [
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'Text',
                decorations: [],
              },
            },
          ],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    expectedOutput: {
      blocks: [
        {
          key: '0tsbe2',
          type: 'unstyled',
          text: 'Text',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
      documentStyle: {},
      VERSION: '9.5.18',
      ID: '05375aa2-e66a-412d-b4b1-1bcb9d3d7130',
    },
  },
  {
    type: 'WITH LINEBREAK',
    input: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: '873qd2',
          nodes: [
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
          ],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    expectedOutput: {
      blocks: [
        {
          key: '873qd2',
          type: 'unstyled',
          text: '\n',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
      documentStyle: {},
      VERSION: '9.5.18',
      ID: '05375aa2-e66a-412d-b4b1-1bcb9d3d7130',
    },
  },
  {
    type: 'WITH LINEBREAK AND TEXT',
    input: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: '873qd2',
          nodes: [
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'Sveiki,',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'V',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'I',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'S',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'I',
                decorations: [],
              },
            },
          ],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    expectedOutput: {
      blocks: [
        {
          key: '873qd2',
          type: 'unstyled',
          text: 'Sveiki,\nV\nI\nS\nI',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
      documentStyle: {},
      VERSION: '9.5.18',
      ID: '05375aa2-e66a-412d-b4b1-1bcb9d3d7130',
    },
  },
  {
    type: 'WITH LINEBREAK AND TEXT AND ESCAPE CHARS',
    input: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: '873qd2',
          nodes: [
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\\Svei\\ki,\\\\',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'V',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'I\\nS',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'I',
                decorations: [],
              },
            },
          ],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    expectedOutput: {
      blocks: [
        {
          key: '873qd2',
          type: 'unstyled',
          text: '\\Svei\\ki,\\\\\nV\nI\\nS\nI',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
      documentStyle: {},
      VERSION: '9.5.18',
      ID: '05375aa2-e66a-412d-b4b1-1bcb9d3d7130',
    },
  },
  {
    type: 'WITH STYLING',
    input: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'yg8xv71',
          nodes: [
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'S',
                decorations: [
                  {
                    type: 'BOLD',
                    fontWeightValue: 700,
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'tyling! ',
                decorations: [
                  {
                    type: 'ITALIC',
                    italicData: true,
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'Lets',
                decorations: [
                  {
                    type: 'UNDERLINE',
                    underlineData: true,
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: ' ',
                decorations: [
                  {
                    type: 'COLOR',
                    colorData: {
                      foreground: '#f7f7f7',
                    },
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'go',
                decorations: [
                  {
                    type: 'BOLD',
                    fontWeightValue: 700,
                  },
                ],
              },
            },
          ],
          paragraphData: {
            indentation: 0,
            textStyle: {
              textAlignment: 'AUTO',
            },
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    expectedOutput: {
      blocks: [
        {
          key: 'yg8xv71',
          type: 'unstyled',
          text: 'Styling! Lets go',
          depth: 0,
          inlineStyleRanges: [
            {
              style: 'BOLD',
              offset: 0,
              length: 1,
            },
            {
              style: 'BOLD',
              offset: 14,
              length: 2,
            },
            {
              style: 'ITALIC',
              offset: 1,
              length: 8,
            },
            {
              style: 'UNDERLINE',
              offset: 9,
              length: 4,
            },
            {
              style: '{"FG":"#f7f7f7"}',
              offset: 13,
              length: 1,
            },
          ],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
      documentStyle: {},
      VERSION: '9.5.18',
      ID: '05375aa2-e66a-412d-b4b1-1bcb9d3d7130',
    },
  },
  {
    type: 'WITH STYLING AND LINEBREAKS',
    input: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'nokfd796',
          nodes: [
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'S',
                decorations: [
                  {
                    type: 'BOLD',
                    fontWeightValue: 700,
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'ty',
                decorations: [
                  {
                    type: 'ITALIC',
                    italicData: true,
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'ling! ',
                decorations: [
                  {
                    type: 'ITALIC',
                    italicData: true,
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'Let',
                decorations: [
                  {
                    type: 'UNDERLINE',
                    underlineData: true,
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: '\n',
                decorations: [],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 's',
                decorations: [
                  {
                    type: 'UNDERLINE',
                    underlineData: true,
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: ' ',
                decorations: [
                  {
                    type: 'COLOR',
                    colorData: {
                      foreground: '#f7f7f7',
                    },
                  },
                ],
              },
            },
            {
              type: 'TEXT',
              id: '',
              nodes: [],
              textData: {
                text: 'go',
                decorations: [
                  {
                    type: 'BOLD',
                    fontWeightValue: 700,
                  },
                ],
              },
            },
          ],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2023-02-07T08:10:25.498Z',
        updatedTimestamp: '2023-02-07T08:10:25.498Z',
        id: '05375aa2-e66a-412d-b4b1-1bcb9d3d7130',
      },
      documentStyle: {},
    },
    expectedOutput: {
      blocks: [
        {
          key: 'nokfd796',
          type: 'unstyled',
          text: 'Sty\nling! Let\ns go',
          depth: 0,
          inlineStyleRanges: [
            {
              style: 'BOLD',
              offset: 0,
              length: 1,
            },
            {
              style: 'BOLD',
              offset: 16,
              length: 2,
            },
            {
              style: 'ITALIC',
              offset: 1,
              length: 2,
            },
            {
              style: 'ITALIC',
              offset: 4,
              length: 6,
            },
            {
              style: 'UNDERLINE',
              offset: 10,
              length: 3,
            },
            {
              style: 'UNDERLINE',
              offset: 14,
              length: 1,
            },
            {
              style: '{"FG":"#f7f7f7"}',
              offset: 15,
              length: 1,
            },
          ],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
      documentStyle: {},
      VERSION: '9.5.18',
      ID: '05375aa2-e66a-412d-b4b1-1bcb9d3d7130',
    },
  },
] as unknown as TestValues[];
